<mat-nav-list class="ori-navigation-menu">
  <div class="ori-navigation-menu__item-container">
    <ng-container *ngFor="let item of visibleItems">
      <a mat-list-item
        *ngIf="!item.children; else parent" 
        [routerLink]="'/' + item.path" 
        class="ori-navigation-menu__item"
        routerLinkActive="active"
        >{{item.title}}</a>
        
      <ng-template #parent>
        <mat-list-item 
          class="ori-navigation-menu__parent-item"
          (click)="item.collapsed = !item.collapsed" 
          [ngClass]="{'ori-navigation-menu__parent-item--opened': !item.collapsed}">
          <a class="ori-navigation-menu__parent-button">
              {{item.title}}
              <mat-icon *ngIf="item.collapsed; else arrow">chevron_right</mat-icon>
              <ng-template #arrow>
                <mat-icon>expand_more</mat-icon>
              </ng-template>
          </a>
          <div class="ori-navigation-menu__child-items" [hidden]="item.collapsed">
            <mat-list-item 
              class="ori-navigation-menu__child-item"
              *ngFor="let child of item.children"
              [routerLink]="'/' + item.path + '/' + child.path"
              routerLinkActive="active"
              (click)="openChild(child.path, item.path, $event)"
              >
              <a >{{child.title}}</a>
            </mat-list-item>
          </div>
        </mat-list-item>
      </ng-template>
    </ng-container>
  </div>
  <div class="ori-navigation-menu__mode-toggle">
    <mat-slide-toggle [ngModel]="sidebarClosingMode" (ngModelChange)="onModeChange($event)">Закрывать меню</mat-slide-toggle>
  </div>
</mat-nav-list>

